import { useState, useRef, useEffect } from 'react'
import getSortItems from '../../../functions/getSortItems'
import Button from '../../general/Button'
import EditAllMoviesListItem from './EditAllMoviesListItem'
import Translation from '../../Translation/cont/Translation'
import getEvenOddByIndex from '../../../functions/getEvenOddByIndex'

const EditAllMoviesListHeaderItem =({transId}) => (
    <div className="text-xsmall-light">
        <Translation id={transId} />
    </div>
)

const EditAllMoviesList = ({movies, moviesOrder, metaMovies, movieMappings, tmdbMovies, listHeaderRef, isSticky, onNavigate}) => {
    const checkList = [
        {
            transId: "tmdb_label",
        },
        {
            transId: "movie_edit_movie_short_description",
            keys: ['descriptionShort'],
            check: 'notEmpty'
        },
        {
            transId: "movie_edit_movie_description",
            keys: ['description'],
            check: 'notEmpty'
        },
        {
            transId: "movie_attributes_fsk",
            keys: ['fsk'],
            check: 'fskExist'
        },
        {
            transId: "movie_attributes_length",
            keys: ['length'],
            check: 'notEmpty'
        },
        {
            transId: "movie_attributes_orig_title",
            keys: ['origTitle'],
            check: 'notEmpty'
        },
        {
            transId: "movie_edit_movie_trailer",
            keys: ['trailerURL'],
            check: 'notEmpty'
        },
        {
            transId: "movie_edit_movie_logo",
            keys: ['logo'],
            check: 'notEmpty'
        },
        {
            transId: "images_movie_poster",
            keys: ['images', 'poster'],
            check: 'notEmpty'
        },
        {
            transId: "images_movie_ambient_image",
            keys: ['images', 'ambient'],
            check: 'notEmpty'
        },
        {
            transId: "images_movie_wallpapers",
            keys: ['images', 'backgrounds'],
            check: 'lengthNotZero'
        }
    ]

    const [sortList, setSortList] = useState('alphabetical')
    const [filter, setFilter] = useState('all')
    const scrollWrapperRef = useRef(null)
    const [canScrollLeft, setCanScrollLeft] = useState(false)
    const [canScrollRight, setCanScrollRight] = useState(false)

    const checkScroll = (el) => {
        setCanScrollLeft(el.scrollLeft > 0)
        setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 1)
    }

    useEffect(() => {
        const el = scrollWrapperRef.current
        if (el) checkScroll(el)
    }, [])

    const handleHorizontalScroll = (e) => {
        checkScroll(e.currentTarget)
    }

    const moviesKeys = Object.keys(movies)
    const metaMoviesKeys = Object.keys(metaMovies)

    let sortedMovies
    let i = 0

    if('alphabetical' === sortList) {
        sortedMovies = getSortItems('titleDisplay', 'alphabetical', moviesKeys, movies, 'title')
    } else if ('newest' === sortList) {
        sortedMovies = getSortItems('created_at', 'date', metaMoviesKeys, metaMovies)
    } else if ('sorting' === sortList) {
        sortedMovies =  moviesOrder
    }

    if ('preview' === filter) {
        sortedMovies = sortedMovies.filter(moviePk => {
            const movie = movies[moviePk]
            return !movie || !movie.performances || 0 === movie.performances.length
        })
    } else if ('withPerformances' === filter) {
        sortedMovies = sortedMovies.filter(moviePk => {
            const movie = movies[moviePk]
            return movie && movie.performances && 0 < movie.performances.length
        })
    }

    return (
        <div className="edit-all-movies-list">
            <div className="gap-20">
                <h3  className="gap-20 title-list text-regular">Liste sortieren nach:</h3>
                <Button
                    className="button-small button-sort-list"
                    transId="alphabetical"
                    hideText={false}
                    disabled={'alphabetical' === sortList}
                    onClick={() => setSortList('alphabetical')}
                />
                <Button
                    className="button-small button-sort-list"
                    transId="newest"
                    hideText={false}
                    disabled={'newest' === sortList}
                    onClick={() => setSortList('newest')}
                />
                <Button
                    className="button-small button-sort-list"
                    transId="movie_sorting"
                    hideText={false}
                    disabled={'sorting' === sortList}
                    onClick={() => setSortList('sorting')}
                />
            </div>

            <div className="tmdb-filter-pills">
                <button
                    className={'tmdb-filter-pill text-small-regular' + ('all' === filter ? ' active' : '')}
                    onClick={() => setFilter('all')}
                >
                    <Translation id="alle_button" />
                </button>
                <button
                    className={'tmdb-filter-pill text-small-regular' + ('preview' === filter ? ' active' : '')}
                    onClick={() => setFilter('preview')}
                >
                    <Translation id="button_preview" />
                </button>
                <button
                    className={'tmdb-filter-pill text-small-regular' + ('withPerformances' === filter ? ' active' : '')}
                    onClick={() => setFilter('withPerformances')}
                >
                    <Translation id="section_filter_upcoming_movies_with_performances" />
                </button>
            </div>

            <div className="scroll-indicator-wrapper">
                {canScrollLeft && <div className="scroll-fade scroll-fade-left" />}
                {canScrollRight && <div className="scroll-fade scroll-fade-right" />}
                <div className="list-scroll-wrapper" ref={scrollWrapperRef} onScroll={handleHorizontalScroll}>
                    <div className={"liste-header container-checks" + (isSticky ? ' is-sticky' : '')} ref={listHeaderRef}>
                        {checkList.map(({transId}, index) => (
                            <EditAllMoviesListHeaderItem
                                key={index}
                                transId={transId}
                            />
                        ))}
                    </div>

                    <ul className="list-main">
                        {sortedMovies.map(moviePk => {

                            if(movies.hasOwnProperty(moviePk)) {
                                i++

                                return <EditAllMoviesListItem
                                    key={moviePk}
                                    itemData={movies[moviePk]}
                                    checkList={checkList}
                                    evenOddClass={getEvenOddByIndex(i)}
                                    movieMappings={movieMappings}
                                    tmdbMovies={tmdbMovies}
                                    onNavigate={onNavigate}
                                />

                            } else {
                                return ''
                            }
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default EditAllMoviesList
